import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable,throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError,map  } from "rxjs/operators";
import { MyPermissionService } from '../../services/my-permission.service'; 

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
    
    token = localStorage.getItem('bearerToken');

    headers = new HttpHeaders({
        Authorization: this.token,
    });

    options = { headers: this.headers };

    constructor(public router: Router,private http: HttpClient, private permissionService: MyPermissionService) { 
        let impersonate = localStorage.getItem('impersonate');
        if (impersonate) {
            this.options.headers = this.options.headers.set('x-impersonate', impersonate);
        }
    }

    canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
    {
        let postData;
        let url = state.url.split('?')[0];

        if(Object.keys(next.params).length !== 0){
            url = url.replace('/'+url.substr(url.lastIndexOf('/') + 1),'');
            postData = { url : url };
        }
        else if(next.data.userPrefPermissions != undefined){
            postData = { url : url, userPrefPermissions : next.data.userPrefPermissions};
        }
        else{
            postData = { url : url };
        }

        if (postData.url.indexOf('franchise/edit') > -1) {
            // check update notes permission 
            postData.checkUpdateNotespermission = true;
        }
        console.log('checking permissions')
        
        if (!this.permissionService.allowedUrls?.length) {
            this.permissionService.loadPermissions();
        }else{
            const isAllowed = this.permissionService.isUrlAllowed(url,next?.data?.userPrefPermissions);
            if (isAllowed) {
                return true;
            }
        }

        return this.http.post<any>(environment.apiUrl + '/checkPermissions',postData,this.options).pipe(map(permissionData => {
            if(permissionData.data.url_permission_granted == true){
                return true;               
            }
            else {
                localStorage.clear();
                window.location.href = '/login';
            }
        }), catchError(
            error => {
                localStorage.clear();
                window.location.href = '/login';
                return throwError(error);
            }
        ));
    }
}
